import { render, staticRenderFns } from "./RolePermissionSelector.vue?vue&type=template&id=32b5b774&scoped=true&"
import script from "./RolePermissionSelector.vue?vue&type=script&lang=ts&"
export * from "./RolePermissionSelector.vue?vue&type=script&lang=ts&"
import style0 from "./RolePermissionSelector.vue?vue&type=style&index=0&id=32b5b774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b5b774",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCheckbox,VDataTable})
